<template>
  <section class="invoice-area">
    <gs-header :title="`Chi tiết phiếu chi: <span class='shipment-code-display click-copy'>${invoice.id}</span>`"
      :breadcrumbs="[
        { title: 'Quản lý phiếu chi', route: { name: 'invoice' } }
      ]">
      <el-popover ref="confirmPopup" placement="top" width="200" v-model="confirmPopup">
        <p>Bạn chắc chắn muốn xác nhận phiếu chi này?</p>
        <div style="text-align: right; margin: 0">
          <el-button size="small" @click="confirmPopup = false">Không</el-button>
          <el-button type="primary" size="small" :disabled="!confirmPopup" @click.prevent="confirmInvoice">Xác
            nhận</el-button>
        </div>
      </el-popover>

      <el-popover ref="payPopup" placement="top" width="200" v-model="payPopup">
        <p>Bạn chắc chắn muốn thanh toán phiếu chi này?</p>
        <div style="text-align: right; margin: 0">
          <el-button size="small" @click="payPopup = false">Không</el-button>
          <el-button type="primary" size="small" :disabled="!payPopup" @click.prevent="payInvoice">Thanh
            toán</el-button>
        </div>
      </el-popover>

      <el-popover ref="emailPopup" placement="top" width="200" v-model="emailPopup">
        <p>Bạn chắc chắn muốn gửi lại email?</p>
        <div style="text-align: right; margin: 0">
          <el-button size="small" @click="emailPopup = false">Không</el-button>
          <el-button type="primary" size="small" :disabled="!emailPopup" @click.prevent="sendEmail">Gửi</el-button>
        </div>
      </el-popover>

      <!-- <a v-if="invoice.returneds && invoice.returneds.data.length" class="ui mini button"
        @click.prevent="returnedHandler">Danh sách nợ</a>
      <a v-if="invoice.returns && invoice.returns.data.length" class="ui mini button" @click.prevent="returnsHandler">Đã
        truy thu</a> -->
      <!-- <a v-if="!invoice.payer_id" class="ui mini button" @click.prevent="returnHandler">Nợ phải thu</a> -->
      <!-- <i class="el-icon-minus"></i> -->
      <el-button size="small" @click.prevent="exportExcel" icon="el-icon-download">Xuất excel</el-button>
      <el-button size="small" v-if="invoice.total_amount > 0" @click.prevent="showpaymentExtra"><i
          class="fa fa-credit-card"></i> Cấn trừ</el-button>
      <el-button size="small" v-if="invoice.total_amount < 0 || invoice.real_amount < 0" @click.prevent="hardPayment" :loading="doHardPayment"><i
          class="fa fa-credit-card"></i> Trừ ví</el-button>
      <el-button type="primary" size="small" v-popover:confirmPopup v-show="!invoice.confirmer_id"><i
          class="fa fa-check"></i>
        Xác nhận</el-button>
      <el-button type="success" size="small" v-popover:payPopup v-show="invoice.can_payment"><i class="fa fa-money"></i>
        Thanh
        toán</el-button>
      <el-button size="small" v-popover:emailPopup v-show="invoice.payer_id"><i class="fa fa-envelope-o"></i> Gửi
        email</el-button>
    </gs-header>

    <div v-if="invoice.id" class="padding-sm-all margin-top padding-lg-bottom invoice-body">
      <el-row :gutter="20" class="remove-margin">
        <el-col :span="6" class="border-right">
          <h3>Thông tin shop</h3>
          <p v-if="invoice.client">
            <span class="text-title-table">Shop:</span> <span v-if="invoice.client.data.vip"
              class="ui label green mini">Credit</span>
            <span class="ui label grey mini" v-else>Debit</span>
            {{ invoice.client.data.name }}
          </p>
          <p v-if="invoice.client"><span class="text-title-table">Điện thoại:</span> <span class="click-copy">{{
            invoice.client.data.phone
              }}</span></p>
          <p v-if="invoice.client"><span class="text-title-table">Email:</span> <span class="click-copy">{{
            invoice.client.data.email
              }}</span></p>
          <p v-if="invoice.client"><span class="text-title-table">Ví trả trước:</span> <span
              class="text-red click-copy">{{ invoice.client.data.debit_amount | vnd }}</span></p>
          <p v-if="invoice.client"><span class="text-title-table">Ví giao dịch:</span> <span
              class="text-red click-copy">{{ invoice.client.data.money_amount | vnd }}</span></p>
        </el-col>
        <el-col :span="6" class="border-right">
          <h3>Tài khoản ngân hàng</h3>
          <div v-if="!getBankInfo.length">
            {{ invoice.bank_info }}
          </div>
          <div class="margin-bottom" v-for="(item, index) in getBankInfo" :key="index">
            <span class="click-copy">&bullet; {{ item.value }}</span>
          </div>
          <div>
            <span style="color: #999">Lý do:</span> <span class="click-copy">{{ getReason }}</span>
          </div>
        </el-col>
        <el-col :span="6" class="border-right">
          <h3>Kiểm soát</h3>
          <p v-if="invoice.confirmer"><span class="text-title-table">Người duyệt:</span> {{ invoice.confirmer.data.name
            }}
          </p>
          <p><span class="text-title-table">Duyệt lúc:</span> {{ invoice.confirmed_at }}</p>
          <p v-if="invoice.payer"><span class="text-title-table">Thanh toán:</span> {{ invoice.payer.data.name }}</p>
          <p><span class="text-title-table">Thanh toán lúc:</span> {{ invoice.payed_at }}</p>
        </el-col>

        <el-col :span="6" class="border-right">
          <h3>Thanh toán</h3>
          <p>
            <span class="text-bold">1. Tổng COD:</span>
            <span v-if="getCrossCcheckKindCod" class="pull-right text-red click-copy"> {{ getTotalCOD | vnd }}</span>
            <span v-if="getCrossCcheckKindFee || getCrossCcheckKindFee1" class="pull-right text-red click-copy"> {{ 0 | vnd }}</span>
          </p>
          <p v-if="getCrossCcheckKindCod"><span class="text-bold">2. Tổng phí:</span> <span class="pull-right text-red click-copy">{{ getTotalFee - getPayedFee |
            vnd
              }}</span></p>
          <p v-if="getCrossCcheckKindFee"><span class="text-bold">2. Tổng phí:</span> <span class="pull-right text-red click-copy">{{ getTotalFeeDifference |
            vnd
              }}</span></p>
          <p v-if="getCrossCcheckKindFee1"><span class="text-bold">2. Tổng phí:</span> <span class="pull-right text-red click-copy">{{ invoice.debt |
            vnd
              }}</span></p>
          <hr>
          <p><span class="text-bold" title="Tiền cần trả shop">3. {{ invoice.total_amount > 0 ? 'Trả shop' : 'Thu shop'
              }} <small>(1-2)</small>:</span> <span class="pull-right text-red click-copy">{{ invoice.total_amount |
                vnd
              }}</span></p>
          <p><span class="text-bold">4. {{ invoice.money_return > 0 ? 'Truy thu' : 'Đã truy thu' }}:</span> <span
              class="pull-right text-red click-copy">{{ getArearAmount | vnd }}</span></p>
          <p><span class="text-bold" :title="invoice.payment_note">5. Nợ ví trả trước:</span> <span
              class="pull-right text-red click-copy">{{ (invoice.payment_extra * -1) | vnd }}</span></p>
          <hr>
          <p><span class="text-bold" title="Tiền thực trả cho shop">Thực trả:</span> <span
              class="pull-right text-red click-copy">{{ invoice.real_amount | vnd }}</span></p>
        </el-col>
      </el-row>
      <el-row class="margin-top" v-if="invoice.shipments">
        <el-col :span="24">
          <h3>DANH SÁCH VẬN ĐƠN</h3>
          <el-table v-if="getCrossCcheckKindCod" :data="invoice.shipments.data" border style="width: 100%">
            <el-table-column type="index" width="40">
            </el-table-column>

            <el-table-column label="Mã đơn" width="120">
              <template slot-scope="scope">
                <p>
                  <el-tooltip placement="top" content="Mã đơn" class="display-inline">
                    <span class="shipment-code-display click-copy">{{ scope.row.id }}</span>
                  </el-tooltip>
                </p>
                <p>
                  <el-tooltip placement="top" content="Mã đơn HVC" class="display-inline">
                    <span class="shipment-code-display click-copy">{{ scope.row.code }}</span>
                  </el-tooltip>
                </p>
              </template>
            </el-table-column>

            <el-table-column label="Người trả phí" width="105">
              <template slot-scope="scope">
                {{ scope.row.payer_txt }}
              </template>
            </el-table-column>

            <el-table-column label="Tài chính">
              <template slot-scope="scope">
                <p>COD: <span class="text-red">{{ scope.row.amount_for_cross | vnd }}</span></p>
                <p>Tổng phí: <span class="text-red">{{ scope.row.total_fee | vnd }}</span></p>
                <p>Phí đã thu: <span class="text-red">{{ getCompare(scope.row).last_payed_fee | vnd }}</span></p>
                <p>Phí cần thu: <span class="text-red">{{ scope.row.total_fee - getCompare(scope.row).last_payed_fee | vnd }}</span></p>
                <p>Trả shop: <span class="text-red">{{ scope.row.amount_return_shop + getCompare(scope.row).last_payed_fee | vnd }}</span></p>
              </template>
            </el-table-column>

            <el-table-column label="Phí vận chuyển">
              <template slot-scope="scope">
                <p>&nbsp; <span class="text-red pull-right">{{ scope.row.location_fee | vnd }}</span></p>
                <p v-if="scope.row.update_info_fee">Phí cập nhật: <span class="text-red pull-right click-copy">{{
                  scope.row.update_info_fee | vnd
                    }}</span></p>
                <p v-if="scope.row.discount">Giảm giá: <span class="text-red pull-right click-copy">{{
                  scope.row.discount
                  | vnd
                    }}</span></p>
                <p v-if="scope.row.update_info_fee || scope.row.discount">Phí thực: <span
                    class="text-red pull-right click-copy">{{ (parseInt(scope.row.location_fee) +
                      parseInt(scope.row.update_info_fee)) - parseInt(scope.row.discount) | vnd
                    }}</span></p>
              </template>
            </el-table-column>

            <el-table-column label="Chi phí khác">
              <template slot-scope="scope">
                <p>Chuyển hoàn: <span class="text-red">{{ scope.row.return_fee | vnd }}</span></p>
                <p>Vượt cân: <span class="text-red">{{ scope.row.overweight_fee | vnd }}</span></p>
                <p>Giao lại: <span class="text-red">{{ scope.row.re_delivery_fee | vnd }}</span></p>
                <p>Bảo hiểm: <span class="text-red">{{ scope.row.insurrance_fee | vnd }}</span></p>
                <p>COD: <span class="text-red">{{ scope.row.cod_fee_real | vnd }}</span></p>
                <p>Phí dịch vụ: <span class="text-red">{{ scope.row.service_fee | vnd }}</span></p>
              </template>
            </el-table-column>

            <!-- <el-table-column label="Cân nặng">
              <template slot-scope="scope">
                <p>Cân nặng: <span class="text-orange click-copy">{{ scope.row.parcel.data.weight | gam }}</span></p>
                <p>Cân thực tế: <span class="text-orange click-copy">{{ scope.row.parcel.data.real_weight | gam
                    }}</span>
                </p>
              </template>
            </el-table-column> -->

            <el-table-column label="Trạng thái" width="100">
              <template slot-scope="scope">
                <span :class="shipmentStatuses[scope.row.status]">{{ scope.row.status_txt }}</span><br>
                <small v-if="scope.row.is_return">(Chuyển hoàn)</small>
                <small v-if="scope.row.is_part_delivery">(Giao một phần)</small>
              </template>
            </el-table-column>
          </el-table>
          <el-table v-if="getCrossCcheckKindFee" :data="invoice.shipments.data" border style="width: 100%">
            <el-table-column type="index" width="40">
            </el-table-column>

            <el-table-column label="Mã đơn" width="120">
              <template slot-scope="scope">
                <p>
                  <el-tooltip placement="top" content="Mã đơn" class="display-inline">
                    <span class="shipment-code-display click-copy">{{ scope.row.id }}</span>
                  </el-tooltip>
                </p>
                <p>
                  <el-tooltip placement="top" content="Mã đơn HVC" class="display-inline">
                    <span class="shipment-code-display click-copy">{{ scope.row.code }}</span>
                  </el-tooltip>
                </p>
              </template>
            </el-table-column>

            <el-table-column label="Người trả phí" width="105">
              <template slot-scope="scope">
                {{ scope.row.payer_txt }}
              </template>
            </el-table-column>

            <el-table-column label="Chi phí đã thu lần 1" align="right">
              <template slot-scope="scope">
                <p>&nbsp; <span class="text-red pull-right">{{ scope.row.compare_fee.data.last_total_fee | vnd }}</span></p>
              </template>
            </el-table-column>

            <el-table-column label="Phí đối soát">
              <template slot-scope="scope">
                <p>&nbsp; <span class="text-red">{{ scope.row.compare_fee.data.total_fee | vnd }}</span></p>
              </template>
            </el-table-column>

            <el-table-column label="Chênh lệch">
              <template slot-scope="scope">
                <p><span class="text-red">{{ differenceFee(scope.row.compare_fee.data.last_total_fee, scope.row.compare_fee.data.total_fee) | vnd }}</span></p>
              </template>
            </el-table-column>

            <el-table-column label="Tổng tiền đơn hàng">
              <template slot-scope="scope">
                <p><span class="text-red">{{ scope.row.total_fee | vnd }}</span></p>
              </template>
              <!-- <template slot-scope="scope">
                <span :class="shipmentStatuses[scope.row.status]">{{ scope.row.status_txt }}</span><br>
                <small v-if="scope.row.is_return">(Chuyển hoàn)</small>
                <small v-if="scope.row.is_part_delivery">(Giao một phần)</small>
              </template> -->
            </el-table-column>
          </el-table>

          <el-table v-if="getCrossCcheckKindFee1" :data="invoice.shipments.data" border style="width: 100%">
            <el-table-column type="index" width="40">
            </el-table-column>

            <el-table-column label="Mã đơn" width="120">
              <template slot-scope="scope">
                <p>
                  <el-tooltip placement="top" content="Mã đơn" class="display-inline">
                    <span class="shipment-code-display click-copy">{{ scope.row.id }}</span>
                  </el-tooltip>
                </p>
                <p>
                  <el-tooltip placement="top" content="Mã đơn HVC" class="display-inline">
                    <span class="shipment-code-display click-copy">{{ scope.row.code }}</span>
                  </el-tooltip>
                </p>
              </template>
            </el-table-column>

            <el-table-column label="Người trả phí" width="105">
              <template slot-scope="scope">
                {{ scope.row.payer_txt }}
              </template>
            </el-table-column>

            <el-table-column label="Tài chính">
              <template slot-scope="scope">
                <p>Tổng phí: <span class="text-red">{{ scope.row.total_fee | vnd }}</span></p>
                <p>Đã thu: <span class="text-red">{{ getCompare(scope.row).last_payed_fee | vnd }}</span></p>
                <p>Tạm thu: <span class="text-red">{{ getCompare(scope.row).payed_fee | vnd }}</span></p>
              </template>
            </el-table-column>

            <el-table-column label="Phí vận chuyển">
              <template slot-scope="scope">
                <p>&nbsp; <span class="text-red pull-right">{{ scope.row.location_fee | vnd }}</span></p>
                <p v-if="scope.row.update_info_fee">Phí cập nhật: <span class="text-red pull-right click-copy">{{
                  scope.row.update_info_fee | vnd
                    }}</span></p>
                <p v-if="scope.row.discount">Giảm giá: <span class="text-red pull-right click-copy">{{
                  scope.row.discount
                  | vnd
                    }}</span></p>
                <p v-if="scope.row.update_info_fee || scope.row.discount">Phí thực: <span
                    class="text-red pull-right click-copy">{{ (parseInt(scope.row.location_fee) +
                      parseInt(scope.row.update_info_fee)) - parseInt(scope.row.discount) | vnd
                    }}</span></p>
              </template>
            </el-table-column>

            <el-table-column label="Chi phí khác">
              <template slot-scope="scope">
                <p>Chuyển hoàn: <span class="text-red">{{ scope.row.return_fee | vnd }}</span></p>
                <p>Vượt cân: <span class="text-red">{{ scope.row.overweight_fee | vnd }}</span></p>
                <p>Giao lại: <span class="text-red">{{ scope.row.re_delivery_fee | vnd }}</span></p>
                <p>Bảo hiểm: <span class="text-red">{{ scope.row.insurrance_fee | vnd }}</span></p>
                <p>COD: <span class="text-red">{{ scope.row.cod_fee_real | vnd }}</span></p>
                <p>Phí dịch vụ: <span class="text-red">{{ scope.row.service_fee | vnd }}</span></p>
              </template>
            </el-table-column>

            <!-- <el-table-column label="Cân nặng">
              <template slot-scope="scope">
                <p>Cân nặng: <span class="text-orange click-copy">{{ scope.row.parcel.data.weight | gam }}</span></p>
                <p>Cân thực tế: <span class="text-orange click-copy">{{ scope.row.parcel.data.real_weight | gam
                    }}</span>
                </p>
              </template>
            </el-table-column> -->

            <el-table-column label="Trạng thái" width="100">
              <template slot-scope="scope">
                <span :class="shipmentStatuses[scope.row.status]">{{ scope.row.status_txt }}</span><br>
                <small v-if="scope.row.is_return">(Chuyển hoàn)</small>
                <small v-if="scope.row.is_part_delivery">(Giao một phần)</small>
              </template>
            </el-table-column>
          </el-table>

        </el-col>
      </el-row>
    </div>

    <!-- <el-dialog title="Nợ cần thu" :visible.sync="dialogReturner">
      <el-table :data="listReturn" border>
        <el-table-column label="Mã">
          <template slot-scope="scope">
            <a href="" @click.prevent="detailInvoiceBlankTab(scope.row.id)" target="_blank">
              <span class="shipment-code-display click-copy">{{ scope.row.id }}</span>
            </a>
          </template>
        </el-table-column>
        <el-table-column label="Số nợ">
          <template slot-scope="scope">
            <span class="text-red click-copy">{{ scope.row.real_amount | number }}</span>
          </template>
        </el-table-column>
        <el-table-column label="" width="120">
          <template slot-scope="scope">
            <button type="button" :disabled="pendingReturn" class="ui mini violet button"
              @click="returnInvoice(scope.row)">Truy thu</button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog title="Danh sách nợ đã cấn trừ" :visible.sync="dialogReturned">
      <el-table v-if="invoice.relations && invoice.relations.data.length" :data="invoice.relations.data" border>
        <el-table-column label="Mã">
          <template slot-scope="scope">
            <a href="" @click.prevent="detailInvoiceBlankTab(scope.row.id)" target="_blank">
              <span class="shipment-code-display click-copy">{{ scope.row.id }}</span>
            </a>
          </template>
        </el-table-column>
        <el-table-column label="Số nợ">
          <template slot-scope="scope">
            <span class="text-red click-copy">{{ scope.row.total_amount | number }}</span>
          </template>
        </el-table-column>
      </el-table>
      <el-table v-if="invoice.returneds && invoice.returneds.data.length" :data="invoice.returneds.data" border>
        <el-table-column label="Mã" width="100">
          <template slot-scope="scope">
            <a href="" @click.prevent="detailInvoiceBlankTab(scope.row.invoice_id)" target="_blank">
              <span class="shipment-code-display">{{ scope.row.invoice_id }}</span>
            </a>
          </template>
        </el-table-column>
        <el-table-column label="Số tiền đã thu">
          <template slot-scope="scope">
            <span class="text-red click-copy">{{ scope.row.total_amount | number }}</span>
          </template>
        </el-table-column>
        <el-table-column label="Người truy thu">
          <template slot-scope="scope">
            <span class="text-red" v-if="scope.row.returner">{{ scope.row.returner.data.name }} |
              {{ scope.row.returner.data.email }}</span>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog title="Phiếu chi đã truy thu nợ" :visible.sync="dialogReturns">
      <el-table v-if="invoice.returns && invoice.returns.data.length" :data="invoice.returns.data" border>
        <el-table-column label="Mã" width="160">
          <template slot-scope="scope">
            <a href="" @click.prevent="detailInvoiceBlankTab(scope.row.relation_id)" target="_blank">
              Phiếu chi <span class="shipment-code-display click-copy">{{ scope.row.relation_id }}</span>
            </a>
          </template>
        </el-table-column>
        <el-table-column label="Số tiền đã thu">
          <template slot-scope="scope">
            <span class="text-red click-copy">{{ scope.row.total_amount | number }}</span>
          </template>
        </el-table-column>
        <el-table-column label="Người truy thu">
          <template slot-scope="scope">
            <span class="text-red" v-if="scope.row.returner">{{ scope.row.returner.data.name }} |
              {{ scope.row.returner.data.email }}</span>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog> -->

    <el-dialog title="Cấn trừ tiền COD" :visible.sync="dialogPaymentExtra">
      <p>Tác vụ này sẽ cấn trừ tiền COD của phiếu chi này và nạp số tiền đó vào ví trả trước.</p>
      <el-form ref="payment_extra" :rules="rulePaymentExtra" :model="payment_extra" label-width="120px">
        <el-form-item label="Số tiền" prop="payment">
          <el-input v-model="payment_extra.payment"></el-input>
        </el-form-item>
        <el-form-item label="Ghi chú" prop="note">
          <el-input v-model="payment_extra.note"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onPaymentExtra('payment_extra')" :loading="isLoadingPayment">Cấn trừ</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { shipmentStatuses } from 'src/stubs/shipments'
import { confirmInvoice, paymentInvoice, returnInvoice, resendEmail, exportExcel, hardPaymentInvoice, makePaymentExtra } from 'src/api/invoice'
import { removeAccents } from 'src/helpers'
import { CROSS_CHECK_TYPE } from "src/constants"
import { find } from 'lodash'
export default {
  name: 'DetailInvoice',
  data() {
    return {
      confirmPopup: false,
      payPopup: false,
      returnPopup: false,
      emailPopup: false,
      shipmentStatuses: shipmentStatuses,
      // dialogReturner: false,
      // dialogReturned: false,
      // dialogReturns: false,
      dialogPaymentExtra: false,
      pendingReturn: false,
      doHardPayment: false,
      payment_extra: {
        payment: '',
        note: ''
      },
      rulePaymentExtra: {
        payment: [{ required: true, message: 'Vui lòng nhập số tiền.', trigger: 'blur' }],
        note: [{ required: true, message: 'Vui lòng nhập lý do cấn trừ', trigger: 'blur' }]
      },
      isLoadingPayment: false
    }
  },
  methods: {
    ...mapActions('invoice', ['getInvoiceDetail']),
    confirmInvoice() {
      this.confirmPopup = false
      confirmInvoice(this.invoice.id).then(response => {
        if (response.code === 200) {
          this.$message({
            type: 'success',
            message: 'Xác nhận phiếu chi thành công'
          })
          this.getInvoiceDetail({ id: this.$route.params.id, params: { include: 'shipments,returner,client,shipments.compare_fee,shipments.compare,confirmer,payer,shipments.parcel,relations,returns.returner,returneds.returner' } })
        } else {
          this.$message({
            type: 'error',
            message: 'Xác nhận phiếu chi thất bại'
          })
        }
      })
    },
    payInvoice() {
      this.payPopup = false
      paymentInvoice(this.invoice.id).then(response => {
        switch (response.code) {
          case 200:
            this.$message({
              type: 'success',
              message: 'Thanh toán phiếu chi thành công'
            })
            this.getInvoiceDetail({ id: this.$route.params.id, params: { include: 'shipments,returner,client,shipments.compare_fee,shipments.compare,confirmer,payer,shipments.parcel,relations,returns.returner,returneds.returner' } })
            break
          case 422:
            this.$message({
              type: 'error',
              message: response.data.errors
            })
            break
          default:
            this.$message({
              type: 'error',
              message: 'Thanh toán phiếu chi thất bại'
            })
        }
      })
    },
    returnInvoice(invoice) {
      this.pendingReturn = true
      this.returnPopup = false
      let dataReturn = {
        type: 0, // truy thu bằng phiếu chi
        relation_id: this.invoice.id
      }
      returnInvoice(invoice.id, dataReturn).then(response => {
        if (response.code === 200) {
          this.$message({
            type: 'success',
            message: 'Truy thu công nợ phiếu chi thành công'
          })
          this.getInvoiceDetail({ id: this.$route.params.id, params: { include: 'shipments,returner,client,shipments.compare_fee,shipments.compare,confirmer,payer,shipments.parcel,relations,returns.returner,returneds.returner' } })
          // this.getListReturnInvoices()
          this.pendingReturn = false
        } else {
          this.$message({
            type: 'error',
            message: 'Truy thu công nợ phiếu chi thất bại'
          })
          this.pendingReturn = false
        }
      })
    },
    returnHandler() {
      this.dialogReturner = true
      // this.getListReturnInvoices()
    },
    // getListReturnInvoices () {
    //   getAllInvoice({ client_id: this.invoice.client.data.id, is_debt: 1, limit: -1 }).then(response => {
    //     if (response.code === 200) {
    //       this.listReturn = response.data
    //     } else {
    //       this.listReturn = []
    //     }
    //   })
    // },
    returnedHandler() {
      this.dialogReturned = true
    },
    returnsHandler() {
      this.dialogReturns = true
    },
    showpaymentExtra() {
      this.dialogPaymentExtra = true
    },
    detailInvoiceBlankTab(id) {
      window.open('/invoice/' + id)
    },
    sendEmail() {
      this.toggleLoadding(true)
      resendEmail(this.invoice.id).then(response => {
        if (response.code === 200) {
          this.$message({
            type: 'success',
            message: 'Gửi email thành công'
          })
          this.toggleLoadding(false)
        } else {
          this.$message({
            type: 'error',
            message: 'Gửi email thất bại'
          })
          this.toggleLoadding(false)
        }
      })
    },
    exportExcel() {
      this.toggleLoadding(true)
      exportExcel({ uuid: this.invoice.id }).then(response => {
        this.toggleLoadding(false)
        window.location.href = response.full
      })
    },
    hardPayment() {
      this.doHardPayment = true
      hardPaymentInvoice(this.invoice.id).then(response => {
        this.doHardPayment = false
        if (response.code === 200) {
          this.$message({
            type: 'success',
            message: 'Truy thu công nợ phiếu chi thành công'
          })
          this.getInvoiceDetail({ id: this.$route.params.id, params: { include: 'shipments,returner,client,shipments.compare_fee,shipments.compare,confirmer,payer,shipments.parcel,relations,returns.returner,returneds.returner' } })
        } else {
          this.$message({
            type: 'error',
            message: 'Truy thu công nợ phiếu chi thất bại'
          })
        }
      })
    },

    // Payment extra
    onPaymentExtra(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.isLoadingPayment = true
          this.toggleLoadding(true)
          makePaymentExtra(this.invoice.id, this.payment_extra).then(res => {
            this.toggleLoadding(false)
            if (res.code === 200) {
              this.$message({
                type: 'success',
                message: 'Cấn trừ phiếu chi thành công.'
              })
              this.getInvoiceDetail({ id: this.$route.params.id, params: { include: 'shipments,returner,client,shipments.compare_fee,shipments.compare,confirmer,payer,shipments.parcel,relations,returns.returner,returneds.returner' } })
              // window.location.reload()
            } else {
              this.$message({
                type: 'error',
                message: res.data.errors
              })
            }
            this.isLoadingPayment = false
            this.dialogPaymentExtra = false
          })
        } else {
          console.log('Payment false')
          return false
        }
      })
    },
    differenceFee(last_total_fee, total_fee){
      return  total_fee - last_total_fee
    },
    getCompare(shipment) {
      if(!this.invoice.cross_check && !this.invoice.cross_check.data.compares.data.length) {
        return 0
      }

      let compare = find(this.invoice.cross_check.data.compares.data, {code: shipment.code})
      if(!compare) {
        compare = find(this.invoice.cross_check.data.compares.data, {code: shipment.id})
      }

      return compare
    }
  },
  computed: {
    ...mapGetters('invoice', ['invoice', 'getTotalFee', 'getTotalCOD', 'getArearAmount', 'getTotalFeeDifference']),
    getBankInfo() {
      let data = []
      let strings = this.invoice.bank_info.split('|')
      if (strings.length === 1) {
        strings = this.invoice.bank_info.split('.')
      }
      if (strings.length > 2) {
        data = [
          { text: 'Chủ tài khoản', value: removeAccents(strings[1].trim()) },
          { text: 'Số tài khoản', value: strings[2].trim() },
          { text: 'Ngân hàng', value: strings[0].trim() }
        ]
      }
      return data
    },
    getReason() {
      let indexStart = this.invoice.description.indexOf(':')
      let indexEnd = this.invoice.description.indexOf(',')
      let code = this.invoice.description.slice(indexStart, indexEnd)
      return 'Goship' + code + ' - ' + this.invoice.client_id
    },
    getCrossCcheckKindCod() {
      return this.invoice.kind === CROSS_CHECK_TYPE.COD
    },
    getCrossCcheckKindFee() {
      return this.invoice.kind === CROSS_CHECK_TYPE.FEE
    },
    getCrossCcheckKindFee1() {
      return this.invoice.kind === CROSS_CHECK_TYPE.FEE1
    },
    getPayedFee()
    {
      let payed = 0

      if(this.invoice.shipments && this.invoice.shipments.data.length) {
        this.invoice.shipments.data.forEach(shipment => {
          payed += this.getCompare(shipment).last_payed_fee
        });
      }
      return payed
    }
  },
  mounted() {
    this.clickToCopy()
    this.getInvoiceDetail({
      id: this.$route.params.id,
      params: { include: 'shipments,returner,client,shipments.compare_fee,cross_check.compares,confirmer,payer,shipments.parcel,relations,returns.returner,returneds.returner' },
      success: (invoice) => {
        if (invoice.confirmer_id && !invoice.payer_id && invoice.total_amount > 0) {
          // this.getListReturnInvoices()
        }
      }
    })
  }
}
</script>

<style lang="css" scoped>
.border-right {
  border-right: 1px solid #dfe6ec;
}

.invoice-area {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 60px);
  overflow: hidden;
}

.invoice-body {
  flex: 1;
  overflow: auto;
}

.text-title-table {
  color: #999;
}
</style>



// WEBPACK FOOTER //
// DetailInvoice.vue?47e7a5a5